module.exports = __webpack_public_path__ + "img/tata_cliq.d0ae1869.svg";